import { EnvironmentName, EnvironmentType } from "../constants/environments.js";
import { CHROME_EXTENSION_IDS } from "../constants/extensions.js";

export type ProdMystiqueHostToExtensionIdMap = Readonly<{
    [EnvironmentName.PROD]: string;
    prod_emergency_fallback: string;
}>;
export type StagingExtensionMap = Readonly<Record<EnvironmentName, string>>;
export type ReturnType<Type extends EnvironmentType> = Readonly<
    Type extends EnvironmentType.PROD ? ProdMystiqueHostToExtensionIdMap : Type extends EnvironmentType.STAGING ? StagingExtensionMap : never
>;
const MystiqueEnvironmentHostToChromeExtensionIdMap: {
    [Type in EnvironmentType]: ReturnType<Type>;
} = {
    [EnvironmentType.PROD]: {
        [EnvironmentName.PROD]: CHROME_EXTENSION_IDS[EnvironmentName.PROD],
        prod_emergency_fallback: CHROME_EXTENSION_IDS.prod_emergency_fallback,
    },
    [EnvironmentType.STAGING]: CHROME_EXTENSION_IDS,
};
export const getMystiqueHostsToChromeExtensionIdMap = <Type extends EnvironmentType>(params: { environmentType: Type }): Record<string, string> => {
    return MystiqueEnvironmentHostToChromeExtensionIdMap[params.environmentType];
};
